import * as React from "react";

import { coverSrc } from "../../lib/covers";
import Work from "../../types/Work";

// Small cover thumbnail for list rows. Falls back to a generated,
// type-tinted cover with the title's first letter when there's no cover or
// it fails to load.
const WorkThumb: React.FC<{
  work: Work;
  className?: string;
  style?: React.CSSProperties;
}> = ({ work, className, style }) => {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => setFailed(false), [work.coverUrl]);

  const title = work.title;
  const letter = title.trim().charAt(0).toUpperCase() || "?";
  const cls = `work-thumb${className ? ` ${className}` : ""}`;

  return (
    <span className={cls} style={style} aria-hidden="true">
      {work.coverUrl && !failed ? (
        <img
          className="work-thumb-img"
          src={coverSrc(work.coverUrl, "thumb")}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className={`work-thumb-letter cover-${work.workType}`}>
          {letter}
        </span>
      )}
    </span>
  );
};

export default WorkThumb;
